import { UIComponentViewImpl } from '../toolkit/uicomponentview';
import { UIDataModel, UIComponentState } from '../toolkit/uicomponent';
import { MainWrapperCSSStyle } from './mainwrappercss';
import * as React from 'react';
import { HeaderComponent } from '../toolkit/header/headercomponent';
import { MainWrapperComponentProps, MainWrapperComponentHandler } from './mainwrappercomponent';
import { LanguageConst } from '../../utils/resources/languageconst';
import { FooterComponent } from '../toolkit/footer-native/footercomponent';
import './mainwrappercss.css';

export class MainWrapperViewImpl extends UIComponentViewImpl<UIDataModel>
{
    bindHandlers()
    {
        this.onLogoClicked = this.onLogoClicked.bind(this);
        this.onSignInClicked = this.onSignInClicked.bind(this);
        this.onFaqClicked = this.onFaqClicked.bind(this);
        this.onAboutClicked = this.onAboutClicked.bind(this);
        this.onDoItYourselfClicked = this.onDoItYourselfClicked.bind(this);
        this.onCategorySelected = this.onCategorySelected.bind(this);
        this.onMyAccountOptionClicked = this.onMyAccountOptionClicked.bind(this);
        this.onFlashMessageClicked= this.onFlashMessageClicked.bind(this);
    }

    draw(props: MainWrapperComponentProps, state: UIComponentState, cssStyle: MainWrapperCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
            {/* <div id="main-wrapper"> */}
        
        
                    <div id="main-wrapper-div" style={cssStyle.getMainWrapperCSSStyle()}>
                        <div id="logo-div" style={cssStyle.getLogoWrapperCSSStyle()}>
                            <img id="logo-image" onClick={this.onLogoClicked} style={{}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
                        </div>
                       {
                           <>
                            <div id="web-header-main">
                                {
                                    this.getWebHeaderView()
                                }
                            </div>
                             <div id="mobile-header-main">
                            {
                                this.getMobileHeaderView()
                            }
                            </div>
                           </>
                       } 
                    </div>    
                    
                        <div id="content-div">
                        {
                        props.childComponent
                        }
                        </div>
                    {
                        this.createFooterComponent()
                    }
                    {/* </div>              */}
         
           
            </>);
    }

    getWebHeaderView():JSX.Element
    {
        return (
    
                <div style={{width:'100%',height:'100%',}}>
                        {
                            this.createHeaderComponent()
                        }
                        {
                            this.createToolBarComponent()
                        }
                    
                    
                        </div>
        

        );
        
    }

    getMobileHeaderView():JSX.Element{
        return(
            <div style={{width:'100%',height:'100%',textAlign:"right"}}>
            {
                this.createMobileViewComponent()
            }
            </div>
        );
    }
    getMobileView(props: MainWrapperComponentProps, state: UIComponentState, cssStyle: MainWrapperCSSStyle)
    {
        return(
        <>
        <div style={cssStyle.getMobileMainWrapperCSSStyle()}>
               
                <div style={cssStyle.getLogoWrapperCSSStyle()}>
                    <img onClick={this.onLogoClicked} style={{}} src={props.context.getResources().getImage("mpt_logo.svg")}  />
                </div>
                {/* <div style={{width:'78%',height:'100%',textAlign:"right"}}>
                {
                    this.createMobileViewComponent()
                }
                </div> */}
            </div>    
               
                <div  style={{ height: '100%', width: '100%',paddingTop:'60px',backgroundColor: "white",}}>
                {
                   props.childComponent
                }
                </div>
               {
                   this.createFooterComponent()
               }
         </>  );    
    }

    protected createHeaderComponent(): JSX.Element | boolean
    {
        return <HeaderComponent onAboutClicked={this.onAboutClicked} onFaqClicked={this.onFaqClicked} onLanguageChange={(language: LanguageConst) => (this.getUIComponentHandler() as MainWrapperComponentHandler).onLanguageChange(language)} context={this.getUIProps().context}/>;
    }
    protected createMobileViewComponent(): JSX.Element | boolean
    {
        return <HeaderComponent onAboutClicked={this.onAboutClicked} onFaqClicked={this.onFaqClicked} onLanguageChange={(language: LanguageConst) => (this.getUIComponentHandler() as MainWrapperComponentHandler).onLanguageChange(language)} context={this.getUIProps().context}/>;
    }
    
    protected createToolBarComponent(): JSX.Element | boolean
    {
        return false;
    }

    protected createFooterComponent(): JSX.Element | boolean
    {
        return <FooterComponent context={this.getUIProps().context}/>;
    }

    protected onLogoClicked()
    {
        (this.getUIComponentHandler() as MainWrapperComponentHandler).onLogoClicked();
    }
    protected onSignInClicked()
    {
        (this.getUIComponentHandler() as MainWrapperComponentHandler).onSignInClicked();
    }

    protected onCategorySelected(categoryDto: string): void
    {
        (this.getUIProps() as MainWrapperComponentProps).onCategorySelected(categoryDto);
    }

    protected onDoItYourselfClicked()
    {
        (this.getUIComponentHandler() as MainWrapperComponentHandler).onDoItYourselfClicked();
    }

    protected onFaqClicked()
    {
        (this.getUIComponentHandler() as MainWrapperComponentHandler).onFaqClicked();
    }

    protected onFlashMessageClicked()
    {
        (this.getUIComponentHandler() as MainWrapperComponentHandler).onFlashMessageClicked();
    }
 
    protected onAboutClicked()
    {
        console.log("About redirecting");
        (this.getUIComponentHandler() as MainWrapperComponentHandler).onAboutClicked();
    }
    protected onMyAccountOptionClicked(routingFeature: string): void
    {
        (this.getUIComponentHandler() as MainWrapperComponentHandler).onMyAccountOptionClicked(routingFeature);
    }

    
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/mainwrapperview.tsx